import { createRoute } from '@tanstack/react-router'

import { areaRoute } from '@/app/routes/area-layout'
import { lazyPage } from '@/lib/lazy-page'
import { classificationCatalogReleasesGridContract, normalizeDataGridUrlState } from '@/modules/data-grid'

export type EntityClassificationCatalogsSearch = { selected?: string }

export function decodeEntityClassificationCatalogsSearch(
  search: Record<string, unknown>,
): EntityClassificationCatalogsSearch {
  return typeof search.selected === 'string' ? { selected: search.selected } : {}
}

export const EntityClassificationCatalogs = lazyPage(
  () => import('./features/catalog-list/entity-classification-catalogs.lazy'),
  'EntityClassificationCatalogs',
)
export type EntityClassificationCatalogReleasesSearch = {
  q?: string
  qColumns?: string
  filters?: string
  sort?: string
  columns?: string
}

export function decodeEntityClassificationCatalogReleasesSearch(
  search: Record<string, unknown>,
): EntityClassificationCatalogReleasesSearch {
  return normalizeDataGridUrlState(search, classificationCatalogReleasesGridContract)
}

export const EntityClassificationCatalogReleases = lazyPage(
  () => import('./features/catalog-releases/entity-classification-catalog-releases.lazy'),
  'EntityClassificationCatalogReleases',
)
export const EntityClassificationCatalogRelease = lazyPage(
  () => import('./features/catalog-release/entity-classification-catalog-release.lazy'),
  'EntityClassificationCatalogRelease',
)

export const entityClassificationCatalogsRoute = createRoute({
  getParentRoute: () => areaRoute('settings'),
  path: 'classification-catalogs',
  component: EntityClassificationCatalogs,
  validateSearch: decodeEntityClassificationCatalogsSearch,
})

export const entityClassificationCatalogReleaseRoute = createRoute({
  getParentRoute: () => areaRoute('settings'),
  path: 'classification-catalogs/$catalogId/releases/$version',
  component: EntityClassificationCatalogRelease,
})

export const entityClassificationCatalogReleasesRoute = createRoute({
  getParentRoute: () => areaRoute('settings'),
  path: 'classification-catalogs/$catalogId/releases',
  component: EntityClassificationCatalogReleases,
  validateSearch: decodeEntityClassificationCatalogReleasesSearch,
})
